import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Page } from "@models/page";
import { Support } from "@models/support";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";
import { SupportStatusPipe } from "../../../shared/pipes/support-status.pipe";

@Component({
  selector: "app-support-table",
  imports: [
    DatePipe,
    TableModule,
    MatButtonModule,
    MatIconModule,
    PaginatorModule,
    ProgressSpinnerModule,
    SkeletonModule,
    SupportStatusPipe,
  ],
  templateUrl: "./support-table.component.html",
  styleUrl: "./support-table.component.scss",
})
export class SupportTableComponent {
  first = 0;
  rows = 20;

  @Input({ required: true }) data: Page<Support> | null = null;
  @Input() filtered = false;
  @Input() loading = false;

  @Output() viewDetailsClick = new EventEmitter<Support>();
  @Output() pageChange = new EventEmitter<PaginatorState>();
}
